// with-ads.styles
import { IS_PRODUCTION } from 'constants/app'
import styled, { css } from 'styled-components'

export const Wrapper = styled.div<{
  width: number
  leftMargin: number
  rightMargin: number
  leftPadding: number
  rightPadding: number
}>`
  /* Fix: keep the track fixed even with padding */
  box-sizing: border-box;

  width: ${({ width, leftPadding, rightPadding }) => width + leftPadding + rightPadding}px;
  min-width: ${({ width, leftPadding, rightPadding }) => width + leftPadding + rightPadding}px;
  max-width: ${({ width, leftPadding, rightPadding }) => width + leftPadding + rightPadding}px;

  display: flex;
  justify-content: center;

  /* Prevent spill over content */
  overflow: hidden;
  position: relative;
  z-index: 0;

  /* Positioning */
  margin-left: ${({ leftMargin }) => leftMargin}px; /* usually = -width */
  margin-right: ${({ rightMargin }) => rightMargin}px; /* usually = -width */
  padding-left: ${({ leftPadding }) => leftPadding}px; /* gap */
  padding-right: ${({ rightPadding }) => rightPadding}px; /* gap */

  ${!IS_PRODUCTION &&
  css`
    /* Dev-only: visualize Ezoic placeholders (Ezoic uses DIVs, not <ins>) */
    > div[id^='ezoic-pub-ad-placeholder-'] {
      outline: 1px dashed rgba(255, 255, 255, 0.3);
      min-height: 250px;
      display: block;
    }
  `}
`

export const AdSlot = styled.div<{ height: number }>`
  box-sizing: border-box;
  width: 100%;
  min-width: 100%;
  height: ${({ height }) => height}px;
  overflow: hidden;
  contain: content; /* isolates layout/paint of ad iframe */
`
